export default {
    name: 'GridEmpty',
    props: {
        grid: Object
    },
    render(h) {
        let content = null;
        if (this.grid.$scopedSlots.empty) {
            content = this.grid.$scopedSlots.empty()
        }
        if (content) {
            return h(
                'div',
                {
                    class: 'datagrid-empty'
                },
                [
                    content
                ]
            )
        } else {
            return null;
        }
    }
}